// Import dependencies
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-action-list' )
export class AutomatorBuilderItemActionList extends LitElement {
	// Properties
	// Data about the user selector
	@property( { type: Array, attribute: false } ) accessor runOn = [];

	// The list of actions, conditions and loops inside
	@property( { type: Array, attribute: false } ) accessor items = [];

	/**
	 * Disable the Shadow DOM
	 *
	 * @todo Remove this once we move fields to web components
	 * @return {HTMLElement} The component
	 */
	createRenderRoot() {
		return this;
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div>
				${ repeat(
					this.items,
					item => item.id,
					item => {
						if ( item.type === 'loop' ) {
							return html`
								<uap-builder-item-loop
									loop-id=${ item.id }
									loop-logic=${ item.logic }

									.loopFilters=${ item.filters }
									.items=${ item.items }

									.iterableExpression=${ item.iterable_expression }
									.runOn=${ item.run_on }
								></uap-builder-item-loop>
							`;
						}

						// if ( item.type === 'filter' ) {
						//     return html`
						//         <uap-builder-item-filter
						//             filter-id=${ item.id }
						//             filter-logic=${ item.logic }

						//             .conditions=${ item.conditions }
						//             .items=${ item.items }
						//         ></uap-builder-item-filter>
						//     `;
						// }

						// if ( item.type === 'action' ) {
						//     return html`
						//         <uap-builder-item-action
						//             item-id=${ item.id }
						//             item-code=${ item.code }
						//             integration-code=${ item.integration_code }

						//             ?is-item-on=${ item.is_item_on }
						//             ?uses-credit=${ item.miscellaneous.uses_credit }

						//             .fields=${ item.fields }
						//             .tokens=${ item.tokens }
						//             .backup=${ item.backup }
						//         ></uap-builder-item-action>
						//     `;
						// }
					}
				) }
			</div>
		`;
	}
}
